module.exports = __webpack_public_path__ + "img/user-parent.dd68a522.png";